import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
//namespaces
export const DomainNamespace_DiseaseProfile = 'Disease Profile';
export const DomainNamespace_DiseaseProfileEditor = 'Disease Profile Editor';
// permission key const declaration (old)
export const PermissionKey_DiseaseProfile_General = 'disease-profile-general';
export const PermissionKey_DiseaseProfile_Edit = 'disease-profile-edit';
export const PermissionKey_DiseaseProfile_Delete = 'disease-profile-delete';
export const DiseaseProfilePermissionKeys = {
    general: PermissionKey_DiseaseProfile_General,
    delete: PermissionKey_DiseaseProfile_Delete,
    edit: PermissionKey_DiseaseProfile_Edit
};
export const DiseaseProfileEditorPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_DiseaseProfileEditor, defaultUIAccessLevels);
//# sourceMappingURL=consts.js.map